export interface ExternalUser {
  id: string;
  societyId?: string;
  primarySocietyId?: string;
  additionalSocietyIds?: string[];
  civility?: string;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  position?: string;
  roleType: 'ADMIN' | 'ACCOUNTANT' | 'SALES_MANAGER' | 'SALES' | 'SAV_MANAGER';
  permissions: string[];
  showTutorials?: boolean;
  isActive: boolean;
  isAnonymized: boolean;
  passwordChangedAt?: Date;
  lastLoginAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface CreateExternalUserDto {
  societyId: string;
  civility?: string;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  position?: string;
  roleType?: 'ADMIN' | 'ACCOUNTANT' | 'SALES_MANAGER' | 'SALES' | 'SAV_MANAGER';
  permissions?: string[];
  showTutorials?: boolean;
  sendWelcomeEmail?: boolean;
}

export interface UpdateExternalUserDto {
  civility?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  position?: string;
  permissions?: string[];
  showTutorials?: boolean;
}

/**
 * Correspondance avec les rôles Symfony (outil-gestion-prescripteur):
 * - 'ADMIN' → ROLE_PRESCRIBER (administrateur principal de la société, toutes les permissions)
 * - Autres rôles → ROLE_USER_PRESCRIBER (permissions personnalisables selon le rôle)
 */
export const ROLE_TYPE_LABELS: Record<string, string> = {
  ADMIN: 'Administrateur',
  ACCOUNTANT: 'Comptable',
  SALES_MANAGER: 'Responsable commercial',
  SALES: 'Commercial',
  SAV_MANAGER: 'Responsable SAV',
};
